import React from 'react';

import Button from 'components/shared/Button/Button';

const EnrollmentModalFooter = ({
  handleClose,
  showAddLicense,
  formik,
  upsertLicenseMutation,
  handleEnroll,
  enrollMutation,
  selectedLicense
}) => {
  return (
    <div className="flex w-full items-center justify-end gap-3">
      <Button text="Close" color="neutral" onClick={handleClose} style="outlined" />
      {showAddLicense ? (
        <Button
          text="Add new license"
          color="primary"
          onClick={formik.handleSubmit}
          isLoading={upsertLicenseMutation.isPending}
          isDisabled={!formik.isValid || !formik.dirty}
        />
      ) : (
        <Button
          text="Enroll"
          color="primary"
          onClick={handleEnroll}
          isLoading={enrollMutation.isPending}
          isDisabled={!selectedLicense}
        />
      )}
    </div>
  );
};

export default EnrollmentModalFooter;
